import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"


import Seo from "../components/SEO"
import "../styles/new.css"
import "../styles/mobilenew.css"
import im1 from "../images/expph/beachhouseextra.jpg"

const OceanOverlook = () => {


    return (
        <>

            <Seo
                title="Ocean Overlook"
                description="A case study of luxurious remake of ocean overlook."
                image={im1}
            />

            <div className="section">
                <h3 className="centerthis">OCEAN OVERLOOK</h3>
            </div>


            <div className="section">

                <StaticImage placeholder="dominantColor" className="image maxdim" src="../images/expph/beachhouseextra.jpg" alt="beachhouseextra" />
            </div>

            {/* <!--TESTIMONIAL--> */}


            <div className="centerthis casestudytestimonial">
                <article className="article">
                    <p>" It is an honor to work continuously with the team at Nolan Interiors.
                        They are very professional, detailed and creative at everything they do. We at
                        Italgres highly recommend them for all of your designs needs. "</p>
                    <h4>Mr. & Mrs. Mayer </h4>
                </article>

            </div>




            <div className="section">
                <div className="portfolioitemgrid">

                    <div className="ltop"><StaticImage placeholder="dominantColor" className="image" src="../images/bh/h1.jpg" alt="beachhouseextra" /></div>
                    <div className="centerthis mobilemargins">
                        <article className="article ">

                            <p>The Beach House was constructed in 1974 and the interiors still held many of the styles from that decade. </p>
                        </article>
                    </div>


                    <div className="rbottom"><StaticImage placeholder="dominantColor" className="image" src="../images/bh/h3.jpg" alt="beachhouseextra" /></div>

                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>The challenge was to retain some of the old flavor while giving it a modern and minimal touch.</p>
                        </article>
                    </div>



                </div>
            </div>



            <div className="section">
                <div className="portfolioitemgrid">

                    <div className="rtop"><StaticImage placeholder="dominantColor" className="image" src="../images/bh/h4.jpg" alt="beachhouseextra" /></div>

                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>All the non essential parts were stripped away. All that was left was what I would describe as the essence of the House.</p>
                        </article>
                    </div>

                    <div className="lbottom"><StaticImage placeholder="dominantColor" className="image" src="../images/bh/h5.jpg" alt="beachhouseextra" /></div>
                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>The house that stabilizes and organizes our complex lives, give us the feeling of joy and togetherness.</p>
                        </article>
                    </div>


                </div>
            </div>


            <div className="section">
                <div className="portfolioitemgrid">

                    <div className="ltop"><StaticImage placeholder="dominantColor" className="image" src="../images/bh/h6.jpg" alt="beachhouseextra" /></div>
                    <div className="centerthis mobilemargins">
                        <article className="article ">

                            <p>Sea is a natural resource that is often associated with relaxation and refreshment. It has served as an inexhaustible source of inspiration for artists and designers. </p>
                        </article>
                    </div>


                    <div className="rbottom"><StaticImage placeholder="dominantColor" className="image" src="../images/bh/v1.jpg" alt="beachhouseextra" /></div>

                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>The sea was truly the greatest source of inspiration while designing most of the interiors, because that was what made most of the view.</p>
                        </article>
                    </div>



                </div>
            </div>



            <div className="section">
                <div className="portfolioitemgrid">

                    <div className="rtop"><StaticImage placeholder="dominantColor" className="image" src="../images/bh/v2.jpg" alt="beachhouseextra" /></div>

                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>My vision was to enhance the view and create a feeling of relaxation and peace like that found on a beach, without physically going out of the house at all.</p>
                        </article>
                    </div>

                    <div className="lbottom"><StaticImage placeholder="dominantColor" className="image" src="../images/bh/v3.jpg" alt="beachhouseextra" /></div>
                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>When our clients said that they had never felt so much at "home" in a new house, I knew it was a job well done.</p>
                        </article>
                    </div>


                </div>
            </div>






            <Link to="/white-villa">
                <div className="section">
                    <h3 className="centerthis"><u>NEXT PROJECT</u></h3>
                </div>

            </Link>


        </>

    )
}

export default OceanOverlook

